import {
  fetchWithErrorHandling,
  parseJSONWithBetterErrors,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {useMutation} from '@github-ui/react-query'
import {useChangeGroupGenerationActions, useDiffFilterActions, usePullRequestBasePath} from '../stores/selectors'

export type UpdateWhitespacePreferenceMutationResponse = {
  showChangeGroups: boolean
}

export function useUpdateShowChangeGroupsPreferenceMutation() {
  const basePath = usePullRequestBasePath()
  const {updateChangeGroupPreference} = useChangeGroupGenerationActions()
  const {updateDiffFilter} = useDiffFilterActions()

  return useMutation({
    mutationFn: async ({showChangeGroups}: {showChangeGroups: boolean}) => {
      const apiUrl = `${basePath}/page_data/${PageData.updateShowChangeGroupsPreference}`

      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: {show_change_groups: showChangeGroups ? 'true' : 'false'},
      })

      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json
    },
    onMutate: ({showChangeGroups}) => {
      // Optimistically update the local store to reflect the new preference
      updateChangeGroupPreference(showChangeGroups)
      // Clear the active change group filter when toggling the preference off
      if (!showChangeGroups) {
        updateDiffFilter({activeChangeGroupId: undefined})
      }
    },
  })
}
